export interface AdminBillingTier {
  tier: string;
  displayName: string;
  priceCents: number;
  totalCount: number;
  activeCount: number;
}

export interface AdminBillingSummary {
  subscriptionsTotal: number;
  subscriptionsByStatus: Record<string, number>;
  mrrCents: number;
  creditsUsedThisPeriod: number;
  tiers: AdminBillingTier[];
  generatedAt: string;
}

export interface AdminSubscription {
  subscriptionId: number;
  userId: number | null;
  userEmail: string | null;
  userName: string | null;
  tier: string | null;
  status: string | null;
  currentPeriodEnd: string | null;
  trialEnd: string | null;
  cancelAtPeriodEnd: boolean;
  creditsUsedThisPeriod: number;
  aiAdsThisPeriod: number;
  createdAt: string | null;
}

export interface AdminCreditLedgerEntry {
  id: number;
  subscriptionId: number | null;
  userId: number | null;
  userEmail: string | null;
  delta: number;
  reason: string | null;
  campaignRunId: number | null;
  periodEnd: string | null;
  createdAt: string | null;
}

export const SUBSCRIPTION_STATUSES = ['TRIALING', 'ACTIVE', 'PAST_DUE', 'CANCELED', 'INCOMPLETE'];
export const SUBSCRIPTION_TIERS = ['BRONZE', 'SILVER', 'GOLD'];

export const usd = (cents: number): string =>
  (cents / 100).toLocaleString(undefined, { style: 'currency', currency: 'USD' });
